import { LocationIcon } from 'app/components/location-icon/location-icon';
import { Arrow } from 'app/media';
import { ContainerFixed } from 'app/components/container';
import { ContainerLayoutMode } from 'app/components/container/container';
import { ReactElement } from 'react';

import { Button, Typography } from 'app/component-library-wave';
import { useTranslation } from 'react-i18next';
import { CustomerType } from 'app/store/types/user-context-types';
import { useAppDispatch } from 'app/hooks/redux-thunk';
import { setSelectedCustomerSegment } from 'app/store/actions/user-context-thunks';
import { useAppNavigation } from 'app/utils/navigation-utils';
import styles from './customer-segment-picker.module.scss';
import classNames from 'classnames';

interface Props {
  variant: 'all' | 'enterprise';
}

export const CustomerSegmentPicker = (props: Props): ReactElement => {
  const { t } = useTranslation();
  const { variant } = props;
  const dispatch = useAppDispatch();
  const { goToHomePage } = useAppNavigation();

  const setCustomerSegment = (customerSegment: CustomerType): void => {
    dispatch(setSelectedCustomerSegment(customerSegment));
    if (customerSegment === CustomerType.BEDRIFT) {
      return;
    }
    goToHomePage();
  };

  function LocationButton(props: { customerType: CustomerType; buttonText: string }) {
    const { customerType, buttonText } = props;
    return (
      <Button className={styles.segment} onClick={() => setCustomerSegment(customerType)}>
        <div className={styles.buttonContentContainer}>
          <LocationIcon customerType={customerType} role="presentation" height={48} width={48} />
          <Typography variant="formds-body" component="span" bold={false} underline={true}>
            {buttonText}
          </Typography>
        </div>
      </Button>
    );
  }

  return (
    <ContainerFixed mode={ContainerLayoutMode.Medium}>
      <main className={styles.customerSegmentSelectorContainer}>
        {variant === 'enterprise' && (
          <div className={classNames(styles.switchSegmentContainer)}>
            <Typography component="h3" variant="formds-common-subtitle-primary" bold={true}>
              {t('features.segmentSelector.switchSegmentHeader')}
            </Typography>
            <Button className={styles.segment} onClick={() => setCustomerSegment(CustomerType.BEDRIFT)}>
              <Typography variant="formds-body" component="span" bold={false} underline={true}>
                {t('features.segmentSelector.switchSegmentButton')}
              </Typography>
            </Button>
          </div>
        )}
        {variant === 'all' && (
          <div className={styles.locationSelectorContainer}>
            <Typography
              id="customerSegmentSelectorHeader"
              variant="formds-common-header-tertiary"
              bold={true}
              component="h1"
            >
              {t('features.segmentSelector.header')}
            </Typography>
            <Typography id="customerSegmentSelectorSubtitle" variant="formds-lead" component="p">
              {t('features.segmentSelector.subtitle')}
            </Typography>

            <div className={styles.segmentButtons}>
              {LocationButton({
                customerType: CustomerType.PRIVAT,
                buttonText: t('features.segmentSelector.private'),
              })}
              {LocationButton({
                customerType: CustomerType.BEDRIFT,
                buttonText: t('features.segmentSelector.enterprise'),
              })}
            </div>
          </div>
        )}
      </main>
    </ContainerFixed>
  );
};
